import * as React from 'react'
import { clsx } from 'clsx'

import styles from './Loader.module.css'

type LoaderProps = React.ComponentPropsWithoutRef<'div'> & {
  /**
   * Optional className to extend the component's styling
   */
  className?: string
}

const Loader = React.forwardRef<HTMLDivElement, LoaderProps>(
  ({ className, ...props }, ref) => {
    return (
      <div ref={ref} className={clsx(styles.loader, className)} {...props}>
        <svg
          width="36"
          height="40"
          viewBox="0 0 36 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          role="img"
        >
          <title>Loading</title>
          <path
            className={styles.top}
            d="M17.914 0.695986L35.258 9.66199L17.89 18.579L0.707985 9.64801L17.914 0.695986Z"
          />
          <path
            className={styles.middle}
            d="M0.723011 20.194L6.135 17.512L17.895 23.345L29.782 17.505L35.336 20.205L17.894 28.671L0.723011 20.194Z"
          />
          <path
            className={styles.bottom}
            d="M0.68401 30.536L6.12902 27.58L17.896 34.015L29.783 27.626L35.283 30.537L17.897 39.842L0.68401 30.536Z"
          />
        </svg>
      </div>
    )
  },
)

Loader.displayName = 'Loader'

export { Loader }
